export default "__VITE_ASSET__DG_n5haq__"